import _WeakMap from "@babel/runtime-corejs3/core-js-stable/weak-map";
import { useRef, useMemo } from 'react';
export function useRefMap() {
  var refMap = useRef(new _WeakMap());
  return useMemo(function () {
    var createItemRef = function createItemRef(item) {
      return function (ref) {
        return refMap.current.set(item, ref);
      };
    };

    var getItemRef = function getItemRef(item) {
      return refMap.current.get(item);
    };

    return [createItemRef, getItemRef];
  }, []);
}